module.exports = __webpack_public_path__ + "img/w3_question_dark.fb25a81f.png";